export const PANEL_PERMISSIONS = {
    DASHBOARD_VIEW: 'dashboard.view',
    ORDERS_VIEW: 'orders.view',
    NOTIFICATIONS_VIEW: 'notifications.view',
    JOBS_VIEW: 'jobs.view',
    USERS_VIEW: 'users.view',
    LOGS_VIEW: 'logs.view',
    SETTINGS_VIEW: 'settings.view',
    ACCESS_LOGS_VIEW: 'access_logs.view'
} as const;

export type PanelPermission = (typeof PANEL_PERMISSIONS)[keyof typeof PANEL_PERMISSIONS];

export interface PanelPermissionOption {
    key: PanelPermission;
    label: string;
}

export const PANEL_PERMISSION_OPTIONS: PanelPermissionOption[] = [
    { key: PANEL_PERMISSIONS.DASHBOARD_VIEW, label: 'Início' },
    { key: PANEL_PERMISSIONS.ORDERS_VIEW, label: 'Pedidos' },
    { key: PANEL_PERMISSIONS.NOTIFICATIONS_VIEW, label: 'Notificações' },
    { key: PANEL_PERMISSIONS.JOBS_VIEW, label: 'Jobs' },
    { key: PANEL_PERMISSIONS.USERS_VIEW, label: 'Usuários' },
    { key: PANEL_PERMISSIONS.LOGS_VIEW, label: 'Logs' },
    { key: PANEL_PERMISSIONS.SETTINGS_VIEW, label: 'Configurações' },
    { key: PANEL_PERMISSIONS.ACCESS_LOGS_VIEW, label: 'Logs de acesso' }
];

export const ALL_PANEL_PERMISSION_KEYS: PanelPermission[] = PANEL_PERMISSION_OPTIONS.map((option) => option.key);

/** Ordem de prioridade para a tela inicial após login / redirect de `/`. */
export const PANEL_HOME_ROUTES: ReadonlyArray<{ permission: PanelPermission; path: string }> = [
    { permission: PANEL_PERMISSIONS.DASHBOARD_VIEW, path: '/dashboard' },
    { permission: PANEL_PERMISSIONS.ORDERS_VIEW, path: '/dashboard-pedidos' },
    { permission: PANEL_PERMISSIONS.NOTIFICATIONS_VIEW, path: '/dashboard-notifications' },
    { permission: PANEL_PERMISSIONS.JOBS_VIEW, path: '/jobs' },
    { permission: PANEL_PERMISSIONS.USERS_VIEW, path: '/usuarios' },
    { permission: PANEL_PERMISSIONS.LOGS_VIEW, path: '/logs' },
    { permission: PANEL_PERMISSIONS.SETTINGS_VIEW, path: '/configuracoes' },
    { permission: PANEL_PERMISSIONS.ACCESS_LOGS_VIEW, path: '/logs-acesso' }
];

export function resolvePanelHomePath(can: (permission: string) => boolean): string {
    const match = PANEL_HOME_ROUTES.find((route) => can(route.permission));
    return match?.path ?? '/access-denied';
}
